import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChargingParkSubscriptionDto } from '@dto/chargingParkSubscriptionDto';
import { PricingDto } from '@dto/pricingDto';
import { StripeInfoDto } from '@dto/stripeInfoDto';
import { UserDto } from '@dto/userDto';
import { UserProfile } from '@dto/userProfile';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { PaymentsService } from '@services/payments/payments.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { loadStripe } from '@stripe/stripe-js';
import { StripeCustomerDto } from '@dto/StripeCustomerDto';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentMethodAddedDialogContentComponent } from '../../../dialog/payment-method-added-dialog-content/payment-method-added-dialog-content.component';

@Component({
  selector: 'app-charging-park-subscription',
  templateUrl: './charging-park-subscription.component.html',
  styleUrls: ['./charging-park-subscription.component.scss']
})
export class ChargingParkSubscriptionComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'ChargingParkSubscriptionComponent'

  public currentUser: UserDto
  public parkOwner: UserDto
  public parkOwnerStripeAccountId: string
  public thereWasNoPreviousPaymentPethod: boolean = false
  public parkOwnerStripeCustomerId: string
  public pricing: PricingDto
  public formCreated: boolean = false
  public subscriptionFormService: FormService
  public userProfile: UserProfile
  public subscription: ChargingParkSubscriptionDto
  public stripe: any
  public isCreatingStripeForm: boolean = false
  public stripeCustomerProfile: StripeCustomerDto
  public hasStripeCustomerId: boolean = false
  public agreed: boolean = false
  public elements: any

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private stripeInfosService: StripeInfosService,
    private pricingsService: PricingsService,
    private usersService: UsersService,
    public toastService: ToastService,
    public activeModal: NgbActiveModal,
    private dialog: NgbModal,
    public paymentsService: PaymentsService,
    private router: Router,
    injector: Injector
  ) {
    super(pricingsService, injector)
  }

  async ngOnInit() {
    this.loadUser();
    this.setupStripe();
    super.ngOnInit();
  }

  createForm() { }

  async setupStripe() {
    this.paymentsService.getStripePublishableKey().subscribe(async (stripe) => {
      this.stripe = await loadStripe(stripe.publishableKey);
    }, error => {
      console.error(error)
    })
  }

  async loadUser() {
    this.currentUser = this.authenticationService.getLoggedInUser();
    this.loadUserStripeInfo();
    this.usersService.getUserProfile().subscribe(result => {
      this.userProfile = result;
      if (this.userProfile.stripeCustomerId != null) {
        this.hasStripeCustomerId = true;
        this.paymentsService.getCustomer(this.userProfile.stripeCustomerId).subscribe(result => {
          this.stripeCustomerProfile = result;
          this.loadPricing()
        }, error => { console.error(error) })
      }
      else { this.loadPricing() };
    }, error => { });
  }

  loadPricing() {
    if (this.currentUser && this.currentUser.pricingId != null) {
      this.pricingsService.getPricing(this.currentUser.pricingId).subscribe(pricing => {
        this.pricing = plainToClass(PricingDto, pricing)

        this.usersService.getUserNameById(pricing.ownerUserId).subscribe(owner => {
          this.parkOwner = owner
        })
        this.loadOwnerStripeInfo();
        this.createSubscriptionForm();
      }, error => {
        console.error(error)
      })
    }
  }

  loadOwnerStripeInfo() {
    //getStripeInfoOfUser (owner that the payment will go to)
    this.stripeInfosService.getStripeInfoOfUser(this.pricing.ownerUserId).subscribe(stripeInfo => {
      this.parkOwnerStripeAccountId = stripeInfo.stripeAccountId;
    }, error => { console.error(error) });
  }

  loadUserStripeInfo() {
    //getStripeInfoOfUser (user that wants to charge here)
    this.stripeInfosService.getStripeInfoOfUser(this.currentUser.id).subscribe(stripeInfo => {
      this.thereWasNoPreviousPaymentPethod = stripeInfo.stripePaymentMethodId == null;
    }, error => { console.error(error) });
  }

  createSubscriptionForm() {
    console.log(this.baseUrl)
    this.subscriptionFormService = new FormService();

    this.subscriptionFormService.validators = {
      email: [Validators.required, Validators.email],
      company: [],
      name: [Validators.required, Validators.minLength(2), Validators.pattern(/[a-zA-Z \.]*/)],
      line1: [Validators.required, Validators.minLength(3), Validators.pattern(/[0-9a-zA-Z ]*/)],
      line2: [],
      postalCode: [Validators.required],
      city: [Validators.required, Validators.minLength(2), Validators.pattern(/[a-zA-Z ]*/)],
    }

    this.subscriptionFormService.form = new UntypedFormGroup({
      email: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.email : this.userProfile.email, this.subscriptionFormService.validators['email']),
      company: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.company : this.userProfile.company, this.subscriptionFormService.validators['company']),
      name: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.name : this.userProfile.firstName + ' ' + this.userProfile.lastName, this.subscriptionFormService.validators['name']),
      line1: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.addressLine1 : this.userProfile.address.street + ' ' + this.userProfile.address.houseNumber, this.subscriptionFormService.validators['line1']),
      line2: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.addressLine2 : '', this.subscriptionFormService.validators['line2']),
      postalCode: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.postalCode : this.userProfile.address.postalCode, this.subscriptionFormService.validators['postalCode']),
      city: new UntypedFormControl(this.hasStripeCustomerId ? this.stripeCustomerProfile.city : this.userProfile.address.city, this.subscriptionFormService.validators['city']),
    })

    this.formCreated = true;
  }

  onSubmit(formValue) {
    let chargingParkSubscription = new ChargingParkSubscriptionDto();
    chargingParkSubscription.parkOwnerName = this.parkOwner.company ? this.parkOwner.company : `${this.parkOwner.firstName} ${this.parkOwner.lastName}`
    chargingParkSubscription.parkOwnerStripeAccountId = this.parkOwnerStripeAccountId
    chargingParkSubscription.StripeCustomerId = this.parkOwnerStripeCustomerId
    chargingParkSubscription.stripePriceId = this.pricing.priceId

    chargingParkSubscription.email = formValue.email
    chargingParkSubscription.company = formValue.company
    chargingParkSubscription.name = formValue.name
    chargingParkSubscription.line1 = formValue.line1
    chargingParkSubscription.housenumber = formValue.housenumber
    chargingParkSubscription.postalCode = formValue.postalCode
    chargingParkSubscription.city = formValue.city
    chargingParkSubscription.StripeCustomerId = this.userProfile.stripeCustomerId
    chargingParkSubscription.userId = this.userProfile.id
    chargingParkSubscription.pricingId = this.pricing.id

    chargingParkSubscription.url = window.location.host

    this.isCreatingStripeForm = true
    this.paymentsService.createSetupIntent(chargingParkSubscription).subscribe(subscription => {
      this.subscription = subscription;
      this.createStripeForm()
    }, error => console.error(error))

  }

  createStripeForm() {
    this.elements = this.stripe.elements({
      clientSecret: this.subscription.stripeClientSecret,
      appearance: {
        theme: 'flat',
        rules: {
          '.Label': {
            marginBottom: '0.5rem',
            fontSize: '0.875rem',
            color: '#212529',
            lineHeight: '1.5',
          },
          '.Input': {
            border: '1px solid #ced4da',
            boxShadow: 'inset 0 1px 2px rgb(0, 0, 0, .08)',
            padding: '0.375rem 0.75rem',
            fontSize: '0.875rem',
            color: '#212529',
            lineHeight: '1.5',
          },
        },
        variables: {
          colorPrimary: '#ef7c00',
          colorBackground: '#ffffff',
          colorText: '#000',
          colorDanger: '#df1b41',
          fontFamily: 'Lato, system-ui, sans-serif',
          spacingUnit: '3px',
          borderRadius: '4px',
        }
      }
    })
    const paymentElement = this.elements.create('payment');
    paymentElement.mount('#payment-element');
  }

  onStripeSubmit() {
    this.stripe.confirmSetup({
      elements: this.elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: this.baseUrl + 'profile',
      },
    }).then((result) => {
      if (result.error) {
        this.handleError(result.error);
      } else if (result.setupIntent.status === "succeeded") {
        this.handleSuccess(result.setupIntent);
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  private handleError(error) {
    this.toastService.error(error.message);
    const messageContainer = document.querySelector('#error-message');
    messageContainer.textContent = error.message;
    console.error(error);
  }

  private handleSuccess(setupIntent) {
    this.subscription.paymentMethodId = setupIntent.payment_method;
    this.subscription.pricingId = this.pricing.id;
    this.toastService.loading($localize`:@@SavingPaymentMethodToast:Zahlungsmethode wird gespeichert.`);
    this.paymentsService.createChargingParkSubscription(this.subscription).subscribe((result) => {
      this.subscription = result;
      if (result.paymentMethodId != null) {
        this.toastService.success($localize`:@@SavingPaymentMethodSuccessToast:Zahlungsmethode erfolgreich gespeichert.`, 0, true);
        this.navigateAfterSuccess();
      } else {
        this.toastService.error($localize`:@@SavingPaymentMethodErrorToast:Zahlungsmethode konnte nicht gespeichert werden.`, 0, true);
      }
    }, (error) => console.error(error));
  }

  private navigateAfterSuccess() {
    if (this.thereWasNoPreviousPaymentPethod) {
      this.showNextStepsDialog().then(() => {
        this.navigateAway();
      });
    } else {
      this.navigateAway();
    }
  }

  onCancelClick() {
    this.activeModal.close();
  }

  /**
   * Show an info dialog about the next steps.
   * You can subscribe to user interaction with a simple .then().
   * @returns a promise that resolves when the dialog is closed or dismissed.
   */
  showNextStepsDialog() {
    const dialogRef = this.dialog.open(PaymentMethodAddedDialogContentComponent, { centered: true, backdrop: 'static' });
    // new, already resolved promises are created for the closing and dismissing case.
    //  this allows processing with a single .then in the calling funciton.
    return dialogRef.result.then(() => Promise.resolve(), () => Promise.resolve());
  }

  navigateAway() {
    return this.router.navigate(["/profile"]).then(() => {
      window.location.reload();
    });
  }
}
